export default __webpack_public_path__ + "static/P49-50_GettyImages-1233122089-73d51ca98d5de9757b13cce230164faf.jpg";